
import { LinkTargetProperties } from "../../../../../../global/components/linkSettings/interfaces"
import { HyperLinkBuilder } from "../../../../../commonComponents/inline/hyperLink";
import { useState, useEffect } from "react"
import { getNewlinkTargetProperties } from "../../../../ynet1280/ynetShops/data/ynetshopsData"
import { getCurrentUser } from "../../../../../../global/paywall/paywallUtils";
import { AuthLogOut } from "../../../../../../global/paywall/authOperations";
import { PaywallMenuDataMutam } from "./categoryHeaderMutamWrapper"

interface CategoryHeaderMutamPaywallSideMenuItemsProps {
    paywallMenuDataMutam: PaywallMenuDataMutam
}

 


export const CategoryHeaderMutamPaywallSideMenuItems = (props: CategoryHeaderMutamPaywallSideMenuItemsProps) => {
    const { paywallMenuDataMutam } = props;
    const {paywallMenuItems,subscribeBtnLink} = paywallMenuDataMutam;
    const [user, setUser] = useState(null);
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);

    useEffect(() => {
        const currentUser = getCurrentUser()
        setUser(currentUser);
    }, [])


    const getUsernameFromEmail = (email: string): string => {
        return email.split('@')[0];
    }

    const handleToggleMenu = () => {
        setIsMenuVisible(!isMenuVisible);
    }

    const getUserLabel = () => {
        let label = '';
        if (user) {
            label = user.displayName;
            if (user.displayName.includes('@')) {
                label = getUsernameFromEmail(user.displayName);
            }
            return <div className="display-name" onClick={handleToggleMenu}>שלום, <span>{label}</span></div>;
        }
    };

    const handleDisconectUser = async () => {
        try {
            await AuthLogOut();
            window.location.reload();
        } catch (error) {
            console.log(error);
        }
    }
    const handlePopup = () => {
        setIsPopupVisible(!isPopupVisible);
        if (isPopupVisible) {
            document.body.style.setProperty('overflow-y', 'auto', 'important');
        } else {
            document.body.style.setProperty('overflow-y', 'hidden', 'important');
        }
        document.body.classList.toggle('popup');
    }

    return (
        <div className="CategoryHeaderMutamPaywallSideMenuItemsContainer">
            <div className="digital-edition-label-menu-item">
                <HyperLinkBuilder href={subscribeBtnLink.link} linkTarget={subscribeBtnLink.linkTarget} className="digital-edition">
                            <span className="text">המהדורה הדיגיטלית</span>
                            <span className="calcalist-icon"></span>
                </HyperLinkBuilder>
            </div>
            {user &&
                <div className="user-menu-item">
                    {getUserLabel()}
                    <div className={!isMenuVisible ? 'arrow-icon' : 'arrow-icon rotate'} onClick={handleToggleMenu}></div>
                </div>
            }
            {isMenuVisible && <div className="paywall-menu-items">
                {paywallMenuItems && paywallMenuItems.length > 0 && paywallMenuItems.map((item, index) => {
                    if (!item.title || item.title === "") {
                        return null;
                    }
                    return (
                        <HyperLinkBuilder key={item.itemId} className="menu-item" href={item.link} linkTarget={item.linkTarget}>
                            {item.title}
                        </HyperLinkBuilder>
                    )
                })}
                <div onClick={handlePopup} className="menu-item disconnect">התנתקות</div>
            </div>}
            {isPopupVisible &&
                <>
                    <div className="CalcalistPaywallLoginComponentaOverlay"></div>
                    <div className="CalcalistPaywallLoginComponentaPopup">
                        <div className="inner-container">
                            <div className="logo-container">
                                <div className="digital-edidion-label">המהדורה הדיגיטלית</div>
                                <div className="text">
                                האם אתם בטוחים שברצונכם
                                להתנתק מהמשתמש שלכם?
                            </div>
                                <div className="disconnect-logo"></div>
                            </div>
                    
                            <div className="buttons-contianer">
                                <div onClick={handlePopup} className="button back">חזרה</div>
                                <div onClick={handleDisconectUser} className="button action">כן, התנתק</div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    );
};

export default CategoryHeaderMutamPaywallSideMenuItems;